//=====================================================
//　G001：Web予約トップ
//=====================================================
import { ContentsBox } from "../../common/ContentsBox";
import { ContentsTitle } from "../../common/ContentsTitle";
import { BtnTile } from "../../common/BtnTile";
import { useContext, useEffect } from "react";
import { CtxAuth, CtxClinicInfo, CtxClinicSystemInfo, CtxNewReservation } from "../../utils/Contexts";
import { useHistory } from "react-router-dom";
import { ReservationType, LoginStatusType } from "../../utils/ConstCommon";

export function G001(){
    const cua = useContext(CtxAuth);
    const cci = useContext(CtxClinicInfo);
    const ccsi = useContext(CtxClinicSystemInfo);
    const cnr = useContext(CtxNewReservation);
    const history = useHistory();

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - Web予約トップ";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - Web予約トップ";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //初診ボタンクリック処理
    function clickFirst(){
        cnr.create(ReservationType.First);
        history.push("/reservation/menu");
    }

    //ログインボタンクリック処理
    function clickLogin() {
        if ( cua.checkExpiresIn() !== LoginStatusType.Login ) {
            //ログアウト、ログイン期限切れ
            cua.logout( function(){history.push("/login")} );
        } else {
            //ログイン状態
            history.push('/mypage');
        }
    }

    return (
        <>
            {cci.data.comment.clinicComment1 && 
                <ContentsBox>
                    <div className="text-multiline">{cci.data.comment.clinicComment1}</div>
                </ContentsBox>
            }
            <ContentsBox>
                <ContentsTitle title="ご予約はこちらから" />
                <div className="btn-tile-wrapper">
                    {ccsi.data.usability.new &&
                        <BtnTile iconfont="icon-tooth-white" title="はじめての方はこちら" 
                            onClick={clickFirst} text={cci.data.comment.firstVisitDescription} />
                    }
                    {ccsi.data.usability.followUp &&
                        <BtnTile iconfont="icon-login" title={"再来院の方はこちら\n（患者様ログイン）"} 
                            onClick={clickLogin} text={cci.data.comment.returnVisitDescription} />
                    }
                </div>
            </ContentsBox>
        </>
    )
}